import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Button } from "@material-tailwind/react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MyDomain } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Phone } from "@mui/icons-material";
import dayjs from "dayjs";
import { styled } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import { Autocomplete, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
const StyledPaper = styled(Paper)({
  maxHeight: "380px", // Set maximum height for the dropdown
  overflowY: "auto", // Enable vertical scroll
});
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function ProfileContactInfo() {
  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(user);

  console.log(user?.phoneNumber);
  const parts = user?.phoneNumber.split(" ");
  // Save before space in new const
  const countryCode = parts[0]; // "+972"
  const [countryCodeErr, setcountryCodeErr] = useState(false);

  // Save after space in new const
  const localNumber = parts[1]; // "0527477128"
  console.log(parts);
  console.log(countryCode);
  console.log(localNumber);

  const [CountryPhoneNumbers, setCountryPhoneNumbers] = useState({
    label: countryCode,
    value: countryCode,
  });
  const [ArrayCountryPhoneNumbers, setArrayCountryPhoneNumbers] = useState([
    { label: "+972", value: "+972" },
  ]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const [isDivHovered, setIsDivHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const [FirstName, setFirstName] = useState(user?.firstName);
  const [LastName, setLastName] = useState(user?.lastName);
  const [Email, setEmail] = useState(user?.email);

  // Check user.dateOfBirth and parse it

  // To display or format the date

  const [PhoneNumber, setPhoneNumber] = useState(localNumber);
  const [PhoneNumberErr, setPhoneNumberErr] = useState(false);

  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const [Password, setPassword] = useState("");
  const [Password2, setPassword2] = useState("");
  const [OldPassword, setOldPassword] = useState("");
  const [CheckOldPassword, setCheckOldPassword] = useState(user?.password);

  const [value, setValue] = useState(dayjs("1998-01-17"));

  const [DateOfBirth, setDateOfBirth] = useState(null);
  useEffect(() => {
    // Assuming user.dateOfBirth is in 'DD-MM-YYYY' format.
    const user = JSON.parse(localStorage.getItem("user")); // Example of retrieving from localStorage
    if (user && user?.dateOfBirth) {
      setDateOfBirth(dayjs(user?.dateOfBirth, "DD-MM-YYYY"));
    }
  }, []);

  const [responseMessage, setResponseMessage] = useState("");
  const [ReceiveNotifications, setReceiveNotifications] = useState("0");
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const [showPassword3, setShowPassword3] = React.useState(false);

  const handleClickShowPassword3 = () => setShowPassword3((show) => !show);

  const handleMouseDownPassword3 = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword2 = (event) => {
    event.preventDefault();
  };
  const ReceiveNotificationsFunc = (event) => {
    setReceiveNotifications(event.target.checked ? "1" : "0");
  };

  const [FirstNameErr, setFirstNameErr] = React.useState(false);
  const [LastNameErr, setLastNameErr] = React.useState(false);
  const [EmailErr, setEmailErr] = React.useState(false);
  const [ErrorPassword, setErrorPassword] = React.useState(false);
  const [DateOfBirthErr, setDateOfBirthErr] = React.useState(false);

  const [OldPasswordErr, setOldPasswordErr] = React.useState(false);

  const handleSubmit = (event) => {
    console.log("DateOfBirth");
    console.log(DateOfBirth);
    if (DateOfBirth === null) setDateOfBirthErr(true);
    else setDateOfBirthErr(false);

    console.log(PhoneNumber);

    if (PhoneNumber === "" || PhoneNumber === undefined)
      setPhoneNumberErr(true);
    else setPhoneNumberErr(false);

    if (
      CountryPhoneNumbers === "" ||
      CountryPhoneNumbers === null ||
      CountryPhoneNumbers?.value === ""
    )
      setcountryCodeErr(true);
    else setcountryCodeErr(false);
    console.log(CountryPhoneNumbers);

    const formattedDate = DateOfBirth.format("DD-MM-YYYY");
    //event.preventDefault();

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    regex.test(Email);
    if (regex.test(Email)) setEmailErr(false);
    else setEmailErr(true);

    if (FirstName.length >= 2) setFirstNameErr(false);
    else setFirstNameErr(true);

    if (LastName.length >= 2) setLastNameErr(false);
    else setLastNameErr(true);

    if (OldPassword.length < 2) {
    } else {
      // if (user.Password === OldPassword) setOldPasswordErr(false);
      // else setOldPasswordErr(true);
      // if (user.Password !== OldPassword) {
      //   return;
      // }
      if (Password !== Password2 || Password.length < 2 || Password2 < 2)
        setErrorPassword(true);
      else setErrorPassword(false);

      if (Password !== Password2 || Password.length < 2 || Password2 < 2) {
        return;
      }
    }

    if (Password !== "" && Password2 !== "") {
      if (Password !== Password2 || Password.length < 2 || Password2 < 2) {
        console.log("Password error 1");
        setErrorPassword(true);
        return;
      } else setErrorPassword(false);
      if (FirstNameErr || LastNameErr || EmailErr) {
        console.log("should return!");
        return;
      }
    }
    if (
      DateOfBirth === null ||
      PhoneNumber === "" ||
      CountryPhoneNumbers === "" ||
      CountryPhoneNumbers === null ||
      CountryPhoneNumbers?.value === "" ||
      FirstName.length <= 2 ||
      LastName.length <= 2
    ) {
      return;
    }
    const data = {
      Users: {
        Id: user?.userId,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        DateOfBirth: formattedDate, //"17-01-1998", //formattedDate, //DateOfBirth,
        PhoneNumber: CountryPhoneNumbers?.value + " " + PhoneNumber,
        Password: OldPassword,
      },
      NewPassword: Password,
    };
    axios
      .put(`${MyDomain}Users/UpdateUser`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        setResponseMessage("Data submitted successfully!");
        user.firstName = FirstName;
        user.lastName = LastName;
        user.Email = Email;
        user.dateOfBirth = formattedDate; //"17-01-1998"; //formattedDate; //DateOfBirth; //"17-01-1998"; //DateOfBirth;
        user.phoneNumber = CountryPhoneNumbers?.value + " " + PhoneNumber;
        localStorage.setItem("user", JSON.stringify(user));
        //history.push(`/`);
        setOpenDone(true);
        setDateOfBirthErr(false);
        setEmailErr(false);
        setFirstNameErr(false);
        setLastNameErr(false);
        setOldPasswordErr(false);
        setPhoneNumberErr(false);
        setErrorPassword(false);
        setcountryCodeErr(false);
        setPassword("");
        setPassword2("");
        setOldPassword("");
        setCheckOldPassword(user.Password);
      })
      .catch((err) => {
        setResponseMessage("Error submitting data.");
        console.log(err.response.data);
        if (err.response.data === "Check your password") {
          setOldPasswordErr(true);
        }
      });
  };

  const [openDone, setOpenDone] = useState(false);

  const handleClose2 = () => {
    setOpenDone(false);
  };
  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={openDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>{t("profile.successfullysent")}</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: MyWidth <= 1024 ? "90%" : "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    handleClose2();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Done")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }
  const WindowsForm = () => {
    return (
      <>
        <div style={{ paddingTop: 50 }}>
          <p style={{ fontWeight: 500, fontSize: 25 }}>
            {t("profile.ContactInfo")}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyItems: "flex-start",
          }}
        >
          <p> </p>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                width: "40%",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  paddingBottom: 45,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <TextField
                  id="standard-basic"
                  label={t("profile.Firstname")}
                  variant="standard"
                  style={{ width: "100%", maxWidth: 500 }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                  }}
                  value={FirstName} // Bind the state value to the TextField
                  onChange={(e) => setFirstName(e.target.value)} // Update state on input change
                />
                {FirstNameErr ? (
                  <div style={{ display: "flex", width: "90%" }}>
                    <a style={{ fontSize: 14, color: "red" }}>
                      Please check you first name
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  paddingBottom: 45,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <TextField
                  id="standard-basic"
                  label={t("profile.Lastname")}
                  variant="standard"
                  style={{ width: "100%", maxWidth: 500 }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                  }}
                  value={LastName} // Bind the state value to the TextField
                  onChange={(e) => setLastName(e.target.value)} // Update state on input change
                />
                {LastNameErr ? (
                  <div style={{ display: "flex", width: "90%" }}>
                    <a style={{ fontSize: 14, color: "red" }}>
                      Please check you last name
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div style={{ width: "100%", maxWidth: 500, paddingBottom: 45 }}>
                {/* Ensures the container is 100% width */}
                <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                  {t("profile.Dateofbirth")}
                </p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={DateOfBirth}
                    onChange={(newValue) => setDateOfBirth(newValue)}
                    slotProps={{
                      textField: {
                        variant: "standard", // Removes outer border and keeps only the underline
                        InputProps: {
                          disableUnderline: false, // Ensure underline is shown
                        },
                        sx: {
                          width: "100%", // Enforces full width on the text field
                          "& .MuiInputBase-root:before": {
                            borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                          },
                          "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                            {
                              borderBottom: "1px solid black", // Underline color on hover
                            },
                          "& .MuiInputBase-root:after": {
                            borderBottom: "2px solid #1976d2 ", // Underline color when focused
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{
                          width: "100%", // Ensures TextField spans full width
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "red", // Default border color
                            },
                            "&:hover fieldset": {
                              borderColor: "red", // Hover border color
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "red", // Focus border color
                            },
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
                {DateOfBirthErr ? (
                  <>
                    <a style={{ color: "red", fontSize: 14 }}>
                      Please check Date
                    </a>
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "35%",
                    paddingBottom: 45,
                    flexDirection: "column",
                  }}
                >
                  <Autocomplete
                    sx={{ width: "100%" }}
                    options={ArrayCountryPhoneNumbers}
                    getOptionLabel={(option) => option.label}
                    value={CountryPhoneNumbers}
                    onFocus={() => setIsDrawerOpen(true)} // Open drawer on focus
                    onBlur={() => setIsDrawerOpen(false)} // Close drawer on blur
                    onChange={(event, newValue) =>
                      setCountryPhoneNumbers(newValue)
                    }
                    PaperComponent={(props) => <StyledPaper {...props} />}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("profile.Countrynumber")}
                        variant="standard"
                        style={{
                          width: "100%",
                          maxWidth: 500,
                        }}
                        InputLabelProps={{
                          style: { opacity: 0.5, fontSize: "15px" },
                        }}
                        //error={CityError} // Apply the error state to show red color
                      />
                    )}
                  />
                  {countryCodeErr ? (
                    <>
                      <a style={{ fontSize: 14, color: "red" }}>
                        Please check country code
                      </a>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "60%",
                    flexDirection: "column",
                    paddingBottom: 45,
                  }}
                >
                  <TextField
                    id="standard-basic"
                    label={t("profile.Phone")}
                    variant="standard"
                    style={{ width: "100%" }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" },
                    }}
                    InputProps={{
                      inputProps: {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: {
                          // Remove arrows in all browsers
                          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                          MozAppearance: "textfield", // Firefox
                          appearance: "none", // Standard
                        },
                      },
                    }}
                    value={PhoneNumber}
                    onChange={(e) =>
                      setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))
                    } // Force numbers only
                    //error={PhoneNumberError}
                  />
                  {PhoneNumberErr ? (
                    <>
                      <a style={{ fontSize: 14, color: "red" }}>
                        Please check phonenumber
                      </a>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  paddingBottom: 45,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <TextField
                  id="standard-basic"
                  label={t("profile.email")}
                  variant="standard"
                  style={{ width: "100%", maxWidth: 500 }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                  }}
                  value={Email} // Bind the state value to the TextField
                  onChange={(e) => setEmail(e.target.value)} // Update state on input change
                  disabled
                />
                {EmailErr ? (
                  <div style={{ display: "flex", width: "90%" }}>
                    <a style={{ fontSize: 14, color: "red" }}>
                      Please check your email
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div
              style={{ flexDirection: "column", display: "flex", width: "40%" }}
            >
              <div
                style={{
                  display: "flex",
                  paddingBottom: 45,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <FormControl
                  variant="standard"
                  style={{ width: "100%", maxWidth: 500 }}
                >
                  <InputLabel
                    htmlFor="standard-adornment-password"
                    sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                  >
                    {t("profile.Oldpassword")}
                    {/* Add asterisk to indicate required */}
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showPassword3 ? "text" : "password"}
                    value={OldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword3}
                          onMouseDown={handleMouseDownPassword3}
                        >
                          {showPassword ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {OldPasswordErr ? (
                  <div style={{ display: "flex", width: "90%" }}>
                    <a style={{ fontSize: 14, color: "red" }}>
                      Please check you old password
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  paddingBottom: 45,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <FormControl
                  variant="standard"
                  style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
                >
                  <InputLabel
                    htmlFor="standard-adornment-password"
                    sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                  >
                    {t("profile.NewPassword")}
                    {/* Add asterisk to indicate required */}
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showPassword ? "text" : "password"}
                    value={Password}
                    onChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="standard"
                  style={{ width: "100%", maxWidth: 500 }}
                >
                  <InputLabel
                    htmlFor="standard-adornment-password"
                    sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                  >
                    {t("profile.Confirmpassword")}
                    {/* Add asterisk to indicate required */}
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showPassword2 ? "text" : "password"}
                    value={Password2}
                    onChange={(e) => setPassword2(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                        >
                          {showPassword2 ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {!ErrorPassword ? (
                  <></>
                ) : (
                  <>
                    <p style={{ color: "red" }}>Pleas check new password!</p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div></div>

          {/* <a
            style={{
              fontSize: 14,
              cursor: "pointer",
              color: isDivHovered ? "#6b21a8" : "black",
            }}
            onClick={() => {
              history.push(`/subscriptionpage`);
            }}
            onMouseEnter={() => {
              setIsDivHovered(true);
            }}
            onMouseLeave={() => {
              setIsDivHovered(false);
            }}
          >
            Manage subscriptions
          </a> */}
          <button
            style={{
              borderWidth: 0,
              backgroundColor: "white",
              border: "1px solid black",
              //marginLeft: "5%",
              color: "black",
              marginTop: 45,
              height: 50,
              width: "25%",
              maxWidth: 150,
              minWidth: 120,
            }}
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("profile.Save")}
          </button>
        </div>
      </>
    );
  };
  const MobileForm = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyItems: "flex-start",
            marginBottom: 40,
          }}
        >
          <p> </p>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                width: "100%",
                alignItems: "flex-start",
              }}
            >
              <TextField
                id="standard-basic"
                label={t("profile.Firstname")}
                variant="standard"
                style={{ paddingBottom: 35, width: "100%", maxWidth: 500 }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                }}
                value={FirstName} // Bind the state value to the TextField
                onChange={(e) => setFirstName(e.target.value)} // Update state on input change
              />
              <TextField
                id="standard-basic"
                label={t("profile.Lastname")}
                variant="standard"
                style={{ paddingBottom: 35, width: "100%", maxWidth: 500 }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                }}
                value={LastName} // Bind the state value to the TextField
                onChange={(e) => setLastName(e.target.value)} // Update state on input change
              />

              <div style={{ width: "100%", maxWidth: 500, paddingBottom: 35 }}>
                {/* Ensures the container is 100% width */}
                <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                  {t("profile.Dateofbirth")}
                </p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={DateOfBirth}
                    onChange={(newValue) => setDateOfBirth(newValue)}
                    slotProps={{
                      textField: {
                        variant: "standard", // Removes outer border and keeps only the underline
                        InputProps: {
                          disableUnderline: false, // Ensure underline is shown
                        },
                        sx: {
                          width: "100%", // Enforces full width on the text field
                          "& .MuiInputBase-root:before": {
                            borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                          },
                          "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                            {
                              borderBottom: "1px solid black", // Underline color on hover
                            },
                          "& .MuiInputBase-root:after": {
                            borderBottom: "2px solid #1976d2 ", // Underline color when focused
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{
                          width: "100%", // Ensures TextField spans full width
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "red", // Default border color
                            },
                            "&:hover fieldset": {
                              borderColor: "red", // Hover border color
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "red", // Focus border color
                            },
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
                {DateOfBirthErr ? (
                  <>
                    <a style={{ color: "red", fontSize: 14 }}>
                      Please check Date
                    </a>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "35%",
                    flexDirection: "column",
                    paddingBottom: 45,
                  }}
                >
                  <Autocomplete
                    sx={{ width: "100%" }}
                    options={ArrayCountryPhoneNumbers}
                    getOptionLabel={(option) => option.label}
                    value={CountryPhoneNumbers}
                    onFocus={() => setIsDrawerOpen(true)} // Open drawer on focus
                    onBlur={() => setIsDrawerOpen(false)} // Close drawer on blur
                    onChange={(event, newValue) =>
                      setCountryPhoneNumbers(newValue)
                    }
                    PaperComponent={(props) => <StyledPaper {...props} />}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("profile.Countrynumber")}
                        variant="standard"
                        style={{
                          width: "100%",
                          maxWidth: 500,
                        }}
                        InputLabelProps={{
                          style: { opacity: 0.5, fontSize: "15px" },
                        }}
                        //error={CityError} // Apply the error state to show red color
                      />
                    )}
                  />
                  {countryCodeErr ? (
                    <>
                      <a style={{ fontSize: 14, color: "red" }}>
                        Please check country code
                      </a>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "60%",
                    paddingBottom: 45,
                    flexDirection: "column",
                  }}
                >
                  <TextField
                    id="standard-basic"
                    label={t("profile.Phone")}
                    variant="standard"
                    style={{ width: "100%" }}
                    InputLabelProps={{
                      style: { opacity: 0.5, fontSize: "15px" },
                    }}
                    InputProps={{
                      inputProps: {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: {
                          // Remove arrows in all browsers
                          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                          MozAppearance: "textfield", // Firefox
                          appearance: "none", // Standard
                        },
                      },
                    }}
                    value={PhoneNumber}
                    onChange={(e) =>
                      setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))
                    } // Force numbers only
                    //error={PhoneNumberError}
                  />
                  {PhoneNumberErr ? (
                    <>
                      <a style={{ fontSize: 14, color: "red" }}>
                        Please check phonenumber
                      </a>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <TextField
                id="standard-basic"
                label={t("profile.email")}
                variant="standard"
                style={{ paddingBottom: 35, width: "100%", maxWidth: 500 }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                }}
                value={Email} // Bind the state value to the TextField
                onChange={(e) => setEmail(e.target.value)} // Update state on input change
                disabled
              />
            </div>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                width: "100%",
              }}
            >
              <FormControl
                variant="standard"
                style={{ paddingBottom: 35, width: "100%", maxWidth: 500 }}
              >
                <InputLabel
                  htmlFor="standard-adornment-password"
                  sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                >
                  {t("profile.Oldpassword")}
                  {/* Add asterisk to indicate required */}
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  type={showPassword3 ? "text" : "password"}
                  value={OldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword3}
                        onMouseDown={handleMouseDownPassword3}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <FormControl
                variant="standard"
                style={{ paddingBottom: 35, width: "100%", maxWidth: 500 }}
              >
                <InputLabel
                  htmlFor="standard-adornment-password"
                  sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                >
                  {t("profile.NewPassword")}
                  {/* Add asterisk to indicate required */}
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  type={showPassword ? "text" : "password"}
                  value={Password}
                  onChange={(e) => setPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <FormControl
                variant="standard"
                style={{ paddingBottom: 45, width: "100%", maxWidth: 500 }}
              >
                <InputLabel
                  htmlFor="standard-adornment-password"
                  sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                >
                  Confirm password
                  {/* Add asterisk to indicate required */}
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  type={showPassword2 ? "text" : "password"}
                  value={Password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                      >
                        {showPassword2 ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {!ErrorPassword ? (
                <></>
              ) : (
                <>
                  <p style={{ color: "red" }}>Pleas check your password !</p>
                </>
              )}
            </div>
          </div>
          <button
            style={{
              borderWidth: 0,
              backgroundColor: "white",
              border: "1px solid black",
              //marginLeft: "5%",
              color: "black",
              marginTop: 35,
              height: 50,
              width: "100%",
            }}
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("profile.Save")}
          </button>
        </div>
      </>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        //justifyContent: "center",
        flexDirection: "column",
        paddingLeft: MyWidth <= 768 ? "0%" : "10%",
      }}
    >
      {ModalDone()}
      {MyWidth <= 768 ? <>{MobileForm()}</> : <>{WindowsForm()}</>}
    </div>
  );
}
